import React, { useState, useEffect, useRef } from "react";
import "../styles/CameraAudioVideoStyles.css";
import { useLocation, useNavigate } from "react-router-dom";
import SpeakerImg from "../assets/cameracheck/speaker.png";
import MicrophoneImg from "../assets/cameracheck/mic.png";
import CameraImg from "../assets/cameracheck/camera.png";
import Logger from "../../../utils/Logger";
import { useApi } from "../../../service/ApiContext"; // Import your custom hook
import { useAlert } from "../../../components/AlertContextComponent";
import BackImg from "../assets/cameracheck/back.png";
import strings from "../../../utils/Strings";
import {
  setCurrentCounter,
  setDuration,
  setStatus,
  setIsIndependent,
  setTotalQuestion,
  setTimeSpend,
  setAssessmentId,
} from "../data/redux/AssessmentSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader, { LocalStorage } from "../../../utils/Utils";
import { useCamera } from "../components/CameraContext";
import AssessmentQuestionModuleClient from "../data/ApiClient/AssessmentQuestionModuleClient";
import {
  AssessmentEntity,
  AssessmentListResponse,
} from "../data/response/AssessmentStatusResponse";
import AssessmentDetailsComponent from "../components/AssessmentDetailsComponent";
import { RootState } from "../../../store/store";
import successThumb from "../assets/cameracheck/thumbup.png";
import networkImg from "../assets/cameracheck/network.png";
import { BrowserType } from "../../../interface/BrowserTypeInterface";
import CommonUtils from "../../../utils/Common_Utils";
import { useNetworkQuality } from "../components/networkStabilityCheck";
import { useProctoring } from "../../assessment_activeproctoring/hooks/ActiveProctoringContext";
const CameraAudioDeviceCheck: React.FC = () => {
  const [speakerStatus, setSpeakerStatus] = useState("Checking Speaker...");
  const [micStatus, setMicStatus] = useState("Checking Microphone...");
  const [audioQuality, setAudioQuality] = useState("Checking AudioQuality...");
  const { videoRef, startCamera, stopCamera, isCameraEnabled } = useCamera();
  //Active Proctoring
  const {
    setupStep,
    isCameraStarted,
    isScreenStarted,
    permissionDenied,
    screenPermissionDenied,
    cameraStream,
    startCameraSetup,
    startScreenSetup,
    setIsCameraStarted,
    setIsProctoringActive,
    stopProctoring,
  } = useProctoring();
  const videoProctoringRef = useRef<HTMLVideoElement>(null);

  const audioContextRef = useRef<AudioContext | null>(null);
  const navigate = useNavigate();
  const api = useApi(); // Initialize the custom hook for API requests
  const [isErrorPopup, setIsErrorPopup] = useState(true);
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const networkStatus = useNetworkQuality();
  const { showAlert } = useAlert();
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedAssessment = location.state?.selectedAssessment;
  const [assessmentList, setAssessmentList] = useState<AssessmentEntity[]>([]);
  const [currentAssessment, setCurrentAssessment] =
    useState<AssessmentEntity | null>(selectedAssessment || null);

  const isCameraRequired = (() => {
    const val =
      currentAssessment?.is_camera_required ??
      (currentAssessment as any)?.isCameraRequired ??
      selectedAssessment?.is_camera_required ??
      (selectedAssessment as any)?.isCameraRequired;
    if (typeof val === "boolean") return val;
    if (typeof val === "string")
      return val.toLowerCase() === "true" || val === "1";
    if (typeof val === "number") return val === 1;

    const localVal = LocalStorage.getLocalData(
      strings.localStorage_keys.assessment_details.is_camera_required,
    );
    if (localVal !== null && localVal !== undefined && localVal !== "") {
      return (
        localVal.toString().toLowerCase() === "true" ||
        localVal.toString() === "1"
      );
    }
    return false; // Default to false when not specified so user is not blocked
  })();

  const isCameraValid = !isCameraRequired || isCameraEnabled;

  console.log(location.state, "state values");

  const fetchAssessmentStatus = async () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      const response = await api.get(
        AssessmentQuestionModuleClient.list_assessment,
      );
      const data = response.data as AssessmentListResponse;
      let uniqueAssessments: AssessmentEntity[] = [];

      if (data?.list_assessments?.length > 0) {
        setIsErrorPopup(false);

        const seenAssessmentKeys = new Set<string>();
        const seenAssessmentEntityIds = new Set<string>();

        uniqueAssessments = data.list_assessments.filter((item: AssessmentEntity) => {
          const entityId = String(item.assessment_entity_id || item.assessment_id || "").trim();
          const title = String(
            item.assessment_title ||
            item.assessment_entity_name ||
            ""
          ).trim();
          const key = `${entityId}:::${title}`;

          if (seenAssessmentKeys.has(key) || (entityId && seenAssessmentEntityIds.has(entityId))) {
            return false;
          }

          seenAssessmentKeys.add(key);
          if (entityId) {
            seenAssessmentEntityIds.add(entityId);
          }
          return true;
        });

        setAssessmentList(uniqueAssessments);
        Logger.info("✅ Assessment data fetched:", uniqueAssessments);
      } else {
        Logger.info("⚠️ No assessments returned");
        showAlert({
          show: true,
          title: "Info",
          message: data.error,
          alertType: "info",
          onlyNeedOneButton: true,
          button1Text: "Cancel",
          btn1onPressed() {
            navigate("/dashboard/assessment");
          },
        });
      }
      // Pick relevant assessment to proceed with
      const assessmentPool = uniqueAssessments.length > 0 ? uniqueAssessments : data?.list_assessments || [];
      const targetEntityId =
        selectedAssessment?.assessment_entity_id ||
        LocalStorage.getLocalData(
          strings.localStorage_keys.assessment_details.assessment_entity_id,
        );
      const targetAssessmentId =
        selectedAssessment?.assessment_id ||
        LocalStorage.getLocalData(
          strings.localStorage_keys.assessment_details.assessment_id,
        );

      let matchedAssessment: AssessmentEntity | undefined;

      if (targetEntityId) {
        matchedAssessment = assessmentPool.find(
          (a: any) =>
            a.assessment_entity_id &&
            String(a.assessment_entity_id) === String(targetEntityId),
        );
      }

      if (!matchedAssessment && targetAssessmentId) {
        matchedAssessment = assessmentPool.find(
          (a: any) =>
            a.assessment_id &&
            String(a.assessment_id) === String(targetAssessmentId),
        );
      }

      // If matched, merge with selectedAssessment so all details (e.g. timeLeft, etc.) are kept
      let selected: AssessmentEntity | null = matchedAssessment
        ? { ...(selectedAssessment || {}), ...matchedAssessment }
        : selectedAssessment || null;

      // Only fallback to active or 0th index if no assessment was selected or provided
      if (!selected) {
        selected =
          assessmentPool.find(
            (a: any) =>
              a.candidate_assessment_status ===
              strings.assessment_status.initated ||
              a.candidate_assessment_status ===
              strings.assessment_status.inProgress,
          ) || assessmentPool[0];
      }

      if (!selected) {
        setIsErrorPopup(true);
        showAlert({
          show: true,
          title: "Info",
          message: data.error,
          alertType: "info",
          onlyNeedOneButton: true,
          button1Text: "Cancel",
          btn1onPressed() {
            navigate("/dashboard/assessment");
          },
        });
        return;
      }

      setCurrentAssessment(selected);

      // Proceed with previous logic
      if (
        selected.candidate_assessment_status ===
        strings.assessment_status.initated ||
        selected.candidate_assessment_status ===
        strings.assessment_status.inProgress
      ) {
        dispatch(setAssessmentId(selected.assessment_id || ""));
        dispatch(setCurrentCounter(selected.current_counter));
        dispatch(setDuration(selected.assessment_duration));
        dispatch(setStatus(selected.candidate_assessment_status));
        dispatch(setTimeSpend(selected.time_spend));
        dispatch(setTotalQuestion(selected.total_question));
        dispatch(setIsIndependent(selected.isIndependent));

        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details.duration,
          selected.assessment_duration.toString(),
        );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details.time_spend,
          selected.time_spend.toString(),
        );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details
            .candidate_assessment_status,
          selected.candidate_assessment_status,
        );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details
            .candidate_assessment_status,
          selected.candidate_assessment_status,
        );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details.assessment_id,
          selected.assessment_id || "",
        );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details.current_counter,
          selected.current_counter.toString(),
        );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details.total_question,
          selected.total_question.toString(),
        );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details.isIndependent,
          selected.isIndependent?.toString() ?? "true",
        );
        if (selected.is_camera_required !== undefined) {
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.is_camera_required,
            selected.is_camera_required.toString(),
          );
        }
        if (selected.assessment_entity_id) {
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.assessment_entity_id,
            selected.assessment_entity_id.toString(),
          );
        }
      } else if (
        selected.candidate_assessment_status ===
        strings.assessment_status.notStarted
      ) {
        dispatch(setDuration(selected.assessment_duration));
        dispatch(setTotalQuestion(selected.total_question));
        dispatch(setIsIndependent(selected.isIndependent));
        dispatch(setStatus(selected.candidate_assessment_status));

        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details.duration,
          selected.assessment_duration.toString(),
        );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details
            .candidate_assessment_status,
          selected.candidate_assessment_status,
        );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details
            .candidate_assessment_status,
          selected.candidate_assessment_status,
        );
        Logger.info(
          "$$$$$$$$$$$$$$$$$$$$$$$$$$",
          selected.candidate_assessment_status,
        );
        LocalStorage.setLocalData(
          strings.localStorage_keys.assessment_details.isIndependent,
          selected.isIndependent?.toString() ?? "true",
        );
        if (selected.is_camera_required !== undefined) {
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.is_camera_required,
            selected.is_camera_required.toString(),
          );
        }
        if (selected.assessment_entity_id) {
          LocalStorage.setLocalData(
            strings.localStorage_keys.assessment_details.assessment_entity_id,
            selected.assessment_entity_id.toString(),
          );
        }
        Logger.info("Assessment not started");
      } else if (data.error) {
        setIsErrorPopup(true);
        showAlert({
          show: true,
          title: "Info",
          message: data.error,
          alertType: "info",
          onlyNeedOneButton: true,
          button1Text: "Cancel",
          btn1onPressed() {
            navigate("/dashboard/assessment");
          },
        });
        Logger.info("Assessment ended or invalid status");
      }
    } catch (error) {
      Logger.error("Error fetching assessment status:", error);
      setIsErrorPopup(true);
    } finally {
      Loader.dismissLoading();
    }
  };

  const startCameraWithDelay = () => {
    setTimeout(() => {
      if (videoRef.current) {
        startCamera();
      } else {
        Logger.warn("videoRef.current is not ready after delay.");
      }
    }, 100); // Delay in milliseconds
  };

  // Check microphone
  const checkMicrophone = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach((track) => track.stop());
      setMicStatus("Microphone Detected");
    } catch (error) {
      Logger.error("Microphone error:", error);
      setMicStatus("No Microphone Detected");
    }
  };
  const checkAudioQuality = async () => {
    try {
      // Access microphone
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      // Create AudioContext for audio analysis
      const audioContext = new (
        window.AudioContext || (window as any).webkitAudioContext
      )();
      const analyser = audioContext.createAnalyser();
      const source = audioContext.createMediaStreamSource(stream);

      // Connect the source to the analyser
      source.connect(analyser);
      analyser.fftSize = 256;

      // Retrieve frequency data
      const bufferLength = analyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);
      analyser.getByteFrequencyData(dataArray);

      // Analyze frequency data to check audio quality
      const averageFrequency =
        dataArray.reduce((sum, value) => sum + value, 0) / bufferLength;

      if (averageFrequency > 50) {
        setAudioQuality("AudioQuality Detected");
      } else {
        setAudioQuality("AudioQuality Detected");
      }

      // Clean up
      stream.getTracks().forEach((track) => track.stop());
      audioContext.close();
    } catch (error) {
      setAudioQuality("No AudioQuality Detected");
    }
  };

  // Check speaker
  const checkSpeaker = async () => {
    try {
      const audioContext = new (window.AudioContext || window.AudioContext)();
      audioContextRef.current = audioContext;
      const oscillator = audioContext.createOscillator();
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(440, audioContext.currentTime);
      oscillator.connect(audioContext.destination);
      oscillator.start();
      setTimeout(() => {
        oscillator.stop();
        setSpeakerStatus("Audio Output Detected");
      }, 1000);
    } catch (error) {
      Logger.error("Speaker error:", error);
      setSpeakerStatus("No Audio Output Detected");
    }
  };
  const checkCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });

      // permission success
      setIsCameraStarted(true);
      stream.getTracks().forEach((track) => track.stop());

      startCameraWithDelay();
    } catch (error) {
      console.log("Camera permission denied");

      setIsCameraStarted(false);
      setIsCameraStarted(false);
    }
  };
  // const checkCamera = async () => {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  //     stream.getTracks().forEach((track) => track.stop());
  //     startCameraSetup();
  //   } catch (error) {}
  // };
  // Attach stream to video element
  useEffect(() => {
    const video = videoProctoringRef.current;
    if (!video || !cameraStream) return;
    video.srcObject = cameraStream;
    video.play().catch(() => { });
    return () => {
      video.srcObject = null;
    };
  }, [cameraStream]);

  useEffect(() => {
    // Attempt camera initialization so user can turn on/use camera even if not strictly required
    checkCamera();
    startCameraWithDelay();
    startCamera();
  }, [isCameraRequired]);

  useEffect(() => {
    checkMicrophone();
    checkSpeaker();
    checkAudioQuality();
    fetchAssessmentStatus();
    return () => {
      if (audioContextRef.current) {
        audioContextRef.current.close();
      }
      //Closing Assessment Camera
      // stopCamera();
      // setIsProctoringActive(false);
      // stopProctoring();
      // window.location.reload();
    };
  }, []);

  const getStatusIcon = (status: string, successMessage: string) => {
    if (status === "Detecting") {
      return (
        <div className="status-icon detecting-icon">
          <div className="dot-spinner">
            {[...Array(8)].map((_, i) => (
              <span key={i}></span>
            ))}
          </div>
        </div>
      );
    }

    return status === successMessage ? (
      <div className="status-icon success-icon">
        <img className="thumb-icon" src={successThumb}></img>
        {/* <i className="fas fa-check"></i> */}
      </div>
    ) : (
      <div className="status-icon failed-icon">
        <i className="fas fa-times"></i>
      </div>
    );
  };

  const getVideo = () => {
    return isCameraStarted ? (
      <div style={{ width: "20vh" }}>
        <video
          ref={videoRef}
          autoPlay
          muted
          // width="400"
          // height="85"
          disablePictureInPicture
        />
      </div>
    ) : (
      <img className="icon" src={CameraImg}></img>
    );
  };
  const [isDetecting, setIsDetecting] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDetecting(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div style={{ backgroundColor: "#ffffff", height: "100vh" }}>
      <div className="desktop-ui_assessmentCheck">
        <div className="assessment-header">
          <div className="header-content">
            <img
              src={BackImg}
              className="back-btn"
              onClick={() => {
                //Closing Assessment Camera
                stopCamera();
                setIsProctoringActive(false);
                stopProctoring();

                navigate("/dashboard/assessment");
                window.location.reload();
              }}
            ></img>
            <span className="title">{"Assessment"}</span>
          </div>
          <div className="divider" />
        </div>
        <div className="camera-assessment-container">
          <AssessmentDetailsComponent
            selectedAssessment={currentAssessment || selectedAssessment}
          />
          <div className="right-panelCameraPage">
            <div className="welcome-card">
              <p className="cameracheck-bestwish">
                All the best! {userData.first_name} {userData.last_name}...
              </p>
              <p className="cameracheck-ensuretxt">
                Lets ensure your hardware is ready for the assessment
              </p>

              <div className="device-grid">
                <div
                  className="device-card"
                  style={{
                    width: "250px",
                    cursor: !isCameraEnabled ? "pointer" : "default",
                  }}
                  onClick={() => {
                    if (!isCameraEnabled) {
                      checkCamera();
                      startCamera();
                    }
                  }}
                  title={!isCameraEnabled ? "Click to enable camera" : undefined}
                >
                  <p className="cameracheck-cardtxt">Webcam</p>
                  <div className="video-containers">{getVideo()}</div>
                  <div className="device-status">
                    <div className="status-centeralign">
                      <div className="status-container">
                        {isDetecting ? (
                          <>
                            {getStatusIcon("Detecting", "Detecting")}
                            <p className="status-detecting">Detecting</p>
                          </>
                        ) : !isCameraRequired ? (
                          <>
                            {getStatusIcon(
                              isCameraEnabled
                                ? "Camera Ready"
                                : "Not Required",
                              isCameraEnabled
                                ? "Camera Ready"
                                : "Not Required",
                            )}
                            <p className="status-success">
                              {isCameraEnabled
                                ? "Detected"
                                : "Not Required"}
                            </p>
                          </>
                        ) : (
                          <>
                            {getStatusIcon(
                              isCameraEnabled === true
                                ? "Camera Ready"
                                : "No Camera Detected",
                              "Camera Ready",
                            )}
                            <p
                              className={`${isCameraEnabled
                                ? "status-success"
                                : "status-failed"
                                }`}
                            >
                              {isCameraEnabled ? "Detected" : "Not  Detected"}
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="device-card">
                  <p className="cameracheck-cardtxt">Speaker</p>
                  <img className="icon" src={SpeakerImg}></img>
                  <div className="device-status">
                    <div className="status-centeralign">
                      <div className="status-container">
                        {isDetecting ? (
                          <>
                            {getStatusIcon("Detecting", "Detecting")}
                            <p className="status-detecting">Detecting</p>
                          </>
                        ) : (
                          <>
                            {getStatusIcon(
                              speakerStatus,
                              "Audio Output Detected",
                            )}

                            <p
                              className={`${speakerStatus === "Audio Output Detected"
                                ? "status-success"
                                : "status-failed"
                                }`}
                            >
                              {speakerStatus === "Audio Output Detected"
                                ? "Detected"
                                : "Not Detected"}
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="device-card">
                  <p className="cameracheck-cardtxt">Microphone</p>
                  <img className="icon" src={MicrophoneImg}></img>
                  <div className="device-status">
                    <div className="status-centeralign">
                      <div className="status-container">
                        {isDetecting ? (
                          <>
                            {getStatusIcon("Detecting", "Detecting")}
                            <p className="status-detecting">Detecting</p>
                          </>
                        ) : (
                          <>
                            {getStatusIcon(micStatus, "Microphone Detected")}

                            <p
                              className={`${micStatus === "Microphone Detected"
                                ? "status-success"
                                : "status-failed"
                                }`}
                            >
                              {micStatus === "Microphone Detected"
                                ? "Detected"
                                : "Not Detected"}
                            </p>
                          </>
                        )}
                      </div>
                      {/* <div className="status-container">
                        {getStatusIcon(audioQuality, "AudioQuality Detected")}
                        <p
                          className={`${
                            audioQuality === "AudioQuality Detected"
                              ? "status-success"
                              : "status-failed"
                          }`}
                        >
                          {audioQuality === "AudioQuality Detected"
                            ? "Audio Detected"
                            : "No Audio Detected"}
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="status-row">
                {/* <div className="status-pill">
                  <img src={networkImg} className="network-icon"></img> Network
                  Status:
                  <img src={successThumb} className="thumb-icon"></img>
                  <p
                    className="status-success"
                    style={{ color: networkStatus.color }}
                  >
                    {" "}
                    {networkStatus.label}
                  </p>
                </div> */}
                {/* <div className="status-pill">
                  <img src={networkImg} className="network-icon"></img>
                  Browser Support:
                  {CommonUtils.getBrowserInfo().type === BrowserType.Safari ? (
                    <div className="status-icon failed-icon">
                      <i className="fas fa-times"></i>
                    </div>
                  ) : (
                    <img src={successThumb} className="thumb-icon"></img>
                  )}
                  <p className="status-success">
                    {CommonUtils.getBrowserInfo().type === BrowserType.Safari
                      ? "Bad"
                      : "Good"}
                  </p>
                </div> */}
                <div className="screenshare-parent-pill">
                  <div className="screenshare-pill">
                    <img src={networkImg} className="network-icon"></img>
                    Screen Sharing Access
                    {isScreenStarted &&
                      !screenPermissionDenied &&
                      setupStep === "ready_to_start" ? (
                      <div className="status-container-screen">
                        <img src={successThumb} className="thumb-icon"></img>

                        <p
                          className={`${isScreenStarted &&
                            !screenPermissionDenied &&
                            setupStep === "ready_to_start"
                            ? "status-success"
                            : "status-failed"
                            }`}
                          style={{ marginTop: "13px" }}
                        >
                          {isScreenStarted &&
                            !screenPermissionDenied &&
                            setupStep === "ready_to_start"
                            ? "Access Permitted"
                            : "Access Not Permitted"}
                        </p>
                      </div>
                    ) : (
                      <button
                        className="grant-prm-btn"
                        onClick={startScreenSetup}
                      >
                        Grant Permission
                      </button>
                    )}
                  </div>

                  {/* <div className="screenshare-pill">
                    {isScreenStarted &&
                    !screenPermissionDenied &&
                    setupStep === "ready_to_start" ? (
                      <img src={successThumb} className="thumb-icon"></img>
                    ) : (
                      <div className="status-icon failed-icon">
                        <i className="fas fa-times"></i>
                      </div>
                    )}
                    <p
                      className={`${
                        isScreenStarted &&
                        !screenPermissionDenied &&
                        setupStep === "ready_to_start"
                          ? "status-success"
                          : "status-failed"
                      }`}
                    >
                      {isScreenStarted &&
                      !screenPermissionDenied &&
                      setupStep === "ready_to_start"
                        ? "Access Permitted"
                        : "Access Not Permitted"}
                    </p>
                  </div> */}
                </div>
              </div>
              {isScreenStarted &&
                !screenPermissionDenied &&
                setupStep === "ready_to_start" &&
                micStatus === "Microphone Detected" &&
                isCameraValid &&
                speakerStatus === "Audio Output Detected" && (
                  <div className="status-container-screen">
                    <img
                      src={successThumb}
                      className="thumb-icon"
                      style={{ marginTop: "-15px" }}
                    ></img>

                    <p className={`${"status-success"}`}>
                      All requirements met! Way to go!
                    </p>
                  </div>
                )}
              {/* <p className="note">
                <span className="note-label">Note:</span>{" "}
                <span className="note-text">
                  The system will automatically advance to the next step once
                  the check is finished. If it is not redirected automatically
                  click the button below
                </span>
              </p> */}
              <button
                style={{
                  marginTop:
                    isScreenStarted &&
                      !screenPermissionDenied &&
                      setupStep === "ready_to_start" &&
                      micStatus === "Microphone Detected" &&
                      isCameraValid &&
                      speakerStatus === "Audio Output Detected"
                      ? "40px"
                      : "95px",
                }}
                className={`primary-btn ${isCameraValid &&
                  speakerStatus === "Audio Output Detected" &&
                  micStatus === "Microphone Detected" &&
                  audioQuality === "AudioQuality Detected" &&
                  setupStep === "ready_to_start" &&
                  !isErrorPopup
                  ? "enabled"
                  : "disabled"
                  }`}
                disabled={
                  !(
                    isCameraValid &&
                    speakerStatus === "Audio Output Detected" &&
                    micStatus === "Microphone Detected" &&
                    audioQuality === "AudioQuality Detected" &&
                    setupStep === "ready_to_start" &&
                    !isErrorPopup
                  )
                }
                onClick={() => {
                  const isEnabled =
                    isCameraValid &&
                    speakerStatus === "Audio Output Detected" &&
                    micStatus === "Microphone Detected" &&
                    audioQuality === "AudioQuality Detected" &&
                    setupStep === "ready_to_start" &&
                    !isErrorPopup;

                  if (isEnabled) {
                    const activeAssessment =
                      currentAssessment || selectedAssessment;
                    navigate(
                      activeAssessment?.candidate_assessment_status ===
                        "NOTSTARTED"
                        ? "otp"
                        : "/dashboard/assessment/instruction",
                      {
                        state: {
                          selectedAssessment: activeAssessment, // pass your full list here
                        },
                      },
                    );
                  } else {
                    setIsErrorPopup(true); // Show the popup if isErrorPopup is false
                  }
                }}
              >
                Go to next
              </button>
              {/* <button
                className="secondary-btn"
                onClick={() => {
                  navigate("/dashboard/assessment");
                }}
              >
                Let me do it later
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <div className="mobile-ui_assessmentCheck">
        <p>The assessment is not accessible on mobile devices.</p>{" "}
      </div>
    </div>
  );
};

export default CameraAudioDeviceCheck;
